import { TextInput, type TextInputProps } from "@mantine/core"
import { useDebouncedCallback } from "@mantine/hooks"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { icons } from "../utils"

export function SearchInput({
  value,
  onChange,
  ...props
}: Omit<TextInputProps, "onChange"> & {
  onChange?: (value: string) => void
}) {
  const { t } = useTranslation()
  const [search, setSearch] = useState((value as string) || "")
  const debouncedOnChange = useDebouncedCallback((value: string) => onChange?.(value), 300)

  return (
    <TextInput
      miw="20rem"
      value={search}
      placeholder={t("Search")}
      leftSection={<icons.Search size={16} />}
      rightSection={
        search.length > 0 ? (
          <icons.Remove
            size={16}
            onClick={() => {
              setSearch("")
              debouncedOnChange("")
            }}
          />
        ) : null
      }
      onChange={(e) => {
        const value = e.currentTarget.value
        setSearch(value)
        debouncedOnChange(value)
      }}
      {...props}
    />
  )
}
